// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"doc-details_cardTitle__IEbGD","cardContent":"doc-details_cardContent__O9B1Q"};